module.exports = __webpack_public_path__ + "img/header_dsk.263eb9e.jpg";